import type { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import type { QuoteApprovalData, QuoteApprovalState } from 'src/types/quote-approval';
import { fetchMrQuoteDetails, fetchQuoteDetails } from './api';

const extraReducers = (builder: ActionReducerMapBuilder<QuoteApprovalState>): void => {
  builder.addCase(fetchQuoteDetails('').pending, (state) => {
    state.isLoading = true;
    state.isMakeReady = false;
  });
  builder.addCase(fetchQuoteDetails('').fulfilled, (state, action) => {
    state.isLoading = false;
    state.isMakeReady = false;
    state.data = action?.payload as QuoteApprovalData;
  });
  builder.addCase(fetchQuoteDetails('').rejected, (state) => {
    state.isLoading = false;
  });

  builder.addCase(fetchMrQuoteDetails('').pending, (state) => {
    state.isLoading = true;
    state.isMakeReady = true;
  });
  builder.addCase(fetchMrQuoteDetails('').fulfilled, (state, action) => {
    const payload = action?.payload;
    state.isLoading = false;
    state.isMakeReady = true;
    state.data = payload as QuoteApprovalData;
  });
  builder.addCase(fetchMrQuoteDetails('').rejected, (state) => {
    state.isLoading = false;
  });
};

export default extraReducers;
